import { render, staticRenderFns } from "./RemoveSosPopup.vue?vue&type=template&id=83496330&"
import script from "./RemoveSosPopup.vue?vue&type=script&lang=js&"
export * from "./RemoveSosPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports